export const SHELL: Record<string, string> = {
  'Español': 'Español',
  English: 'English',
  'Switch to Spanish': 'Cambiar a español',
  'Switch to English': 'Cambiar a inglés',
  'Spanish translation': 'Traducción al español',
  'Translates the AI texts for users who picked Spanish': 'Traduce los textos de la IA para quien eligió español',
}
